/**
 * Vehicle card extraction hook — TanStack Query mutation.
 */
import { useMutation } from '@tanstack/react-query'
import { vehicleCardService } from '../services/vehicle-card.service'

type PolicyDocumentInput =
  | string
  | {
      uri: string
      mimeType?: string
      fileName?: string
    }

export function useExtractVehicleCard() {
  return useMutation({
    mutationFn: (photoUri: string) => vehicleCardService.extractFromPhoto(photoUri),
  })
}

export function useExtractInsurancePolicy() {
  return useMutation({
    mutationFn: (input: PolicyDocumentInput) =>
      typeof input === 'string'
        ? vehicleCardService.extractInsurancePolicyFromPhoto(input)
        : vehicleCardService.extractInsurancePolicyFromPhoto(
            input.uri,
            input.mimeType,
            input.fileName,
          ),
  })
}
